import __request__ from "routing/request";
export function getLogGroupNames(JSONbody) {
  return __request__("POST", "/aws/cloudwatch/log_groups", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function create(JSONbody, setup_wizard = false) {
  return __request__("POST", "/aws/inputs", JSONbody, { "setup_wizard": setup_wizard }, {
    "Accept": ["application/json"]
  });
}
export function kinesisHealthCheck(JSONbody) {
  return __request__("POST", "/aws/kinesis/health_check", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function getStreamArn(JSONbody) {
  return __request__("POST", "/aws/kinesis/stream_arn", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function getKinesisStreams(JSONbody) {
  return __request__("POST", "/aws/kinesis/streams", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function getAwsRegions() {
  return __request__("GET", "/aws/regions", null, {}, {
    "Accept": ["application/json"]
  });
}
